module.exports = __webpack_public_path__ + "static/media/list.0a257028.svg";